<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="Programlar Podcast">
                    <b-alert variant="warning" show class="mb-0">
                        <div class="alert-body mb-2">
                            <span><strong>Not:</strong>Anasayfada görüntülenecek 1 adet podcast seçin...</span>
                        </div>
                    </b-alert>
                </b-card>
            </b-col>
        </b-row>
        <validation-observer ref="rules">
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="Programlar Podcast Formu">
                        <b-row>
                            <b-col cols="12">
                                <b-form-group label="Podcast" label-for="content">
                                    <validation-provider #default="{ errors }" :rules="{
                                        required: true
                                    }" name="Podcast">
                                        <v-select id="podcasts" v-model="selectedPodcast" label="title"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="podcasts" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <validation-provider #default="{ errors }" :rules="{ required: true }" name="Metin">
                                    <b-form-input id="text" v-model="text" placeholder="Metin"
                                        :state="errors.length > 0 ? false : null" :class="
                                            text.length >= chars.text
                                                ? 'text-danger'
                                                : ''
                                        " />
                                    <small class="textarea-counter-value float-right" :class="text.length >= chars.text ? 'bg-danger' : '' ">
                                        <span class="char-count">{{ text.length }}</span> / {{ chars.text }}
                                    </small>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <DragDropImage ref="refCardImage" title="Slider Görseli" :imageUrl="null"
                                    :required="true">
                                </DragDropImage>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12">
                                <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
                                    @click="postConfirmText()">
                                    <b-spinner v-if="spinner == true" small />
                                    {{ spinner == true ? "Ekleniyor" : "Ekle" }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <b-card class="mb-3" title="İçerik Listesi">
                        <table class="table b-table">
                            <thead>
                                <th>#</th>
                                <th>GÖRSEL</th>
                                <th>PODCAST ADI</th>
                                <th>İŞLEMLER</th>
                            </thead>
                            <draggable v-if="sliders.length > 0" v-model="sliders" class="cursor-move" tag="tbody"
                                @change="outputData">
                                <tr v-for="slider in sliders" :key="slider.id">
                                    <td>{{ slider.id }}</td>
                                    <td><img :src="slider.images.hero"></td>
                                    <td>{{ slider.podcast.title }}</td>
                                    <td>
                                        <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-danger"
                                            class="btn-icon rounded-circle" @click="deleteConfirmText(slider.id)">
                                            <feather-icon icon="TrashIcon" />
                                        </b-button>
                                    </td>
                                </tr>
                            </draggable>
                            <thead>
                                <th>#</th>
                                <th>GÖRSEL</th>
                                <th>PODCAST ADI</th>
                                <th>İŞLEMLER</th>
                            </thead>
                        </table>
                    </b-card>
                </b-col>
            </b-row>
        </validation-observer>
    </div>
</template>
<script>
import DragDropImage from "../../components/DragDropImage";
import draggable from "vuedraggable";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
    BImg,
    BRow,
    BCol,
    BTime,
    BCard,
    BCardText,
    BButton,
    BForm,
    BMedia,
    BAlert,
    BSpinner,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BLink
} from "bootstrap-vue";
import {
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
    components: {
        BImg,
        BRow,
        BCol,
        BTime,
        BLink,
        BCard,
        BCardText,
        BButton,
        BForm,
        BSpinner,
        BAlert,
        BFormGroup,
        BFormInput,
        BInputGroup,
        BFormTextarea,
        BMedia,
        BMediaAside,
        BMediaBody,
        BFormFile,
        BFormDatepicker,
        vSelect,
        ValidationProvider,
        ValidationObserver,
        required,
        email,
        confirmed,
        url,
        between,
        alpha,
        integer,
        password,
        min,
        digits,
        alphaDash,
        length,
        draggable,
        DragDropImage
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            spinner: false,
            text: '',
            sliders: [],
            podcasts: [],
            selectedPodcast: null,
            chars: {
                text: 100,
            },
        };
    },
    methods: {
        outputData() {
        },
        getPodcasts(slug) {
            endpoints.
                getPodcasts(slug, this.$i18n.locale, () => { })
                .then((data) => {
                    this.podcasts = [];
                    this.podcasts = [...data.response];
                    this.selectedPodcast = this.podcasts[0]
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getSettingsSliderPodcasts() {
            endpoints.
                getSettingsSliderPodcasts(null, this.$i18n.locale, () => { })
                .then((data) => {
                    this.sliders = []
                    this.sliders = [...data.response]
                    console.log(this.sliders)
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        postConfirmText() {
            this.$swal({
                title: "Kayıt?",
                text: "Slider listesine podcasti eklemek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.postSubmit();
                }
            });
        },
        postSubmit() {
            this.$refs.rules.validate().then((success) => {
                if (success) {
                    this.spinner = true;
                    let formData = new FormData();
                    formData.append("text", this.text)
                    formData.append("image", this.$refs.refCardImage.image)
                    formData.append("podcastId", this.selectedPodcast.id)
                    endpoints
                        .postSettingsSliderPodcasts(formData, this.$i18n.locale, () => { })
                        .then((data) => {
                            this.spinner = false;
                            this.$swal({
                                icon: "success",
                                title: "Kayıt başarılı!",
                                text: "Yeni slider eklendi.",
                                customClass: {
                                    confirmButton: "btn btn-success",
                                },
                            }).then((result) => {
                                this.getSettingsSliderPodcasts()
                            });
                        })
                        .catch((err) => {
                            this.spinner = false;
                            console.log(err);
                        });
                }
            });


        },
        deleteConfirmText(id) {
            this.$swal({
                title: "Sil?",
                text: "Slideri silmek istediğinize emin misiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Vazgeç!",
                confirmButtonText: "Kaydet!",
                customClass: {
                    confirmButton: "btn btn-primary",
                    cancelButton: "btn btn-outline-danger ml-1",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (result.value) {
                    this.deleteSubmit(id);
                }
            });
        },
        deleteSubmit(id) {
            console.log(id)
            endpoints
                .deleteSettingsSliderPodcasts(id, this.$i18n.locale, () => { })
                .then((data) => {
                    this.getSettingsSliderPodcasts()
                    this.$swal({
                        icon: "success",
                        title: "Silme başarılı!",
                        text: "Slider silindi",
                        customClass: {
                            confirmButton: "btn btn-success",
                        },
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    created() { },
    destroyed() { },
    mounted() {
        this.getPodcasts()
        this.getSettingsSliderPodcasts()
    },
    setup() {
    }
};
</script>
<style lang="css">
.ql-container {
    margin-top: 30px;
}

.ql-container,
.ql-editor {
    min-height: 300px !important;
    margin-bottom: 30px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
<style>
.draggable-card {
    margin-bottom: 0;
}

.draggable-card>.card-body {
    padding: 10px;
}

.draggable-card>.card-body>.card-title {
    margin-bottom: 0;
    font-size: 1rem;
}

.tree-node {
    border: 0 !important;
}
</style>
